module.exports = __webpack_public_path__ + "img/img_aviodPhoney_02.9bd4f03a.jpg";